import {getActiveBranch} from './messageTree';
import type {AgentChatState, MessageNode, Thread} from './thread';

export interface ThreadListItem {
  id: string;
  title: string | null;
  status: Thread['status'];
}

export function selectThreads(state: AgentChatState): Record<string, Thread> {
  return state.threads;
}

export function selectActiveThreadId(state: AgentChatState): string | null {
  return state.activeThreadId;
}

export function selectActiveThread(state: AgentChatState): Thread | undefined {
  return state.activeThreadId ? state.threads[state.activeThreadId] : undefined;
}

export function selectThreadBranch(
  state: AgentChatState,
  threadId: string,
  upToNodeId?: string
): MessageNode[] {
  const thread = state.threads[threadId];
  return thread ? getActiveBranch(thread.messageTree, upToNodeId) : [];
}

export function selectThreadOrder(state: AgentChatState): string[] {
  return state.threadOrder;
}

export function selectActiveBranch(state: AgentChatState): MessageNode[] {
  return state.activeThreadId
    ? selectThreadBranch(state, state.activeThreadId)
    : [];
}

export function selectIsRunning(state: AgentChatState): boolean {
  const thread = selectActiveThread(state);
  return thread?.status === 'running';
}

export function selectThreadById(
  state: AgentChatState,
  threadId: string
): Thread | undefined {
  return state.threads[threadId];
}

export function selectThreadListItems(state: AgentChatState): ThreadListItem[] {
  return state.threadOrder.map(id => {
    const thread = state.threads[id];
    return {
      id: thread.id,
      title: thread.title,
      status: thread.status,
    };
  });
}
